import objectUtils from '../utils/object-utils'

export default class Org {
  constructor (options = {}) {
    this.model = 'Org'

    this.id = objectUtils.get(options, 'id', null)
    this.org_type_code = objectUtils.get(options, 'org_type_code', null)
    this.owner_id = objectUtils.get(options, 'owner_id', null)
    this.name = objectUtils.get(options, 'name', null)
    this.description = objectUtils.get(options, 'description', null)
    this.email = objectUtils.get(options, 'email', null)
    this.timezone = objectUtils.get(options, 'timezone', null)
    this.prefs = objectUtils.get(options, 'prefs', {})
    this.settings = objectUtils.get(options, 'settings', {})
    this.org_status = objectUtils.get(options, 'org_status', null)

    // Auditing
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)

    // Associations
    if (options.owner) this.owner = options.owner
    if (options.registration_code) this.registration_code = options.registration_code
    if (options.receiver_locations) this.receiver_locations = options.receiver_locations
  }
}
